var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cloundbtn",style:({
    width: ("" + _vm.width),
    height: ("" + _vm.height),
    backgroundImage: _vm.thurl ? ("url(" + _vm.thurl + ")") : ("url(" + _vm.imgUrl + ")"),
  }),on:{"click":_vm.actspanFc}},[_c('span',{class:_vm.actspan ? 'spanone' : 'actspanone'}),_c('span',{class:_vm.actspan ? 'spantwo' : 'actspantwo'}),_c('span',{class:_vm.actspan ? 'spanthree' : 'actspanthree'}),_c('span',{class:_vm.actspan ? 'spanfour' : 'actspanfour'})])}
var staticRenderFns = []

export { render, staticRenderFns }